import { combineReducers } from "redux";
//Reducers
import testReducer from "./test.reducer";
import builderReducer from "./builder.reducer";
//
const combinedReducers = combineReducers({
  testReducer,
  builderReducer,
});
export default combinedReducers;
